// Mês selecionado GLOBAL do módulo financeiro — compartilhado entre Lançamentos,
// sidebar e KPIs. PORTADO do StormFin (apps/web/src/lib/month.tsx); única mudança:
// trpc do V3 + namespace finance.*.
import { createContext, useContext, useState, type ReactNode } from "react";
import { trpc } from "../../lib/trpc.js";

type MonthCtx = { month: string; setMonth: (m: string) => void; months: string[] };

const Ctx = createContext<MonthCtx>({ month: "", setMonth: () => {}, months: [] });

export function MonthProvider({ children }: { children: ReactNode }) {
  const { data: txMonths = [] } = trpc.finance.transactions.months.useQuery();
  const currentMonth = new Date().toISOString().slice(0, 7);
  const months = [...new Set([...txMonths, currentMonth])].sort();
  const [sel, setSel] = useState<string | null>(null);
  const month = sel ?? months[months.length - 1] ?? currentMonth;
  return <Ctx.Provider value={{ month, setMonth: setSel, months }}>{children}</Ctx.Provider>;
}

export function useMonth() {
  return useContext(Ctx);
}
